import cleanedFilename from '~/util/cleanedFilename';

export default {
  VALUATION_REPORT_CONTAINER: `${cleanedFilename(
    __filename,
  )}-valuation-report-container`,
};
